import { createSelector } from '@ngrx/store';

export const getContactTitlesState = createSelector(
    (state: any) => state.contactTitles,
    (state: any) => state.get('list')
);

export const getCreateContactTitleState = createSelector(
    (state: any) => state.contactTitles, 
    (state: any) => state.get('createContactTitle')
);

export const getUpdateContactTitleState = createSelector(
    (state: any) => state.contactTitles,
    (state: any) => state.get('updateContactTitle')
);
